/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Груз
 */
export type OrderCopyCargoBySeparate = {
  /**
   * Тип посылки
   */
  type: OrderCopyCargoBySeparate.type
  /**
   * Высота посылки (в см)
   */
  height: number
  /**
   * Ширина посылки (в см)
   */
  width: number
  /**
   * Длина посылки (в см)
   */
  length: number
  /**
   * Вес посылки (в г)
   */
  weight: number
  /**
   * Характер груза (о грузе)
   */
  about: string
  /**
   * Оценочная стоимость
   */
  price: number
  /**
   * Количество грузомест
   */
  amount: number
}
export namespace OrderCopyCargoBySeparate {
  /**
   * Тип посылки
   */
  export enum type {
    CUSTOM = 'custom',
    PALLET = 'pallet'
  }
}
